import React, { useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import { Input, Tag } from 'antd';
import DF from 'DisplayFramework';
import DataGrid from 'components/DataGrid';
import ParListSelect from 'components/ParListSelect';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import ThirdPartyInput from 'components/ThirdPartyInput';
import ProposalSelect from 'components/ProposalSelect';
import AssetSelect from 'components/AssetSelect';
import SupplierInvoiceSelect from 'components/SupplierInvoiceSelect';
import GuarantySelect from 'components/GuarantySelect';
import CollectionSelect from 'components/CollectionSelect';
import {
  GetListProcTaskByFilter,
  ViewProcTaskResponse,
} from 'services/workflow';
import ProcedureInput from 'components/ProcedureInput';
import TaskModal from 'pages/workflow/TaskModal';
import ModalControllerNV from 'components/ModalControllerNV';
import TaskInput from 'components/TaskInput';
import MultiTaskAssignToUserButton from 'components/MultiTaskAssignToUserButton';

import UsersInput from 'components/UsersList';
import ModalController from 'components/ModalController';
import ThirdPartyModal from 'pages/ThirdParty/ThirdPartyDetail/ThirdPartyModal';
import ProposalModal from 'pages/ProposalV3/ProposalModal';
import AssetDetails from 'pages/Asset/AssetDetail';
import SIDetail from 'pages/SupplierInvoice/SIDetail';
import GuarantDetailModal from 'pages/guaranty/guarantyDetails/guarantyDetailsModal';
import CIDetail from 'pages/ClientInvoice/CIDetail';
import ClientInvoiceSelect from 'components/ClientInvoiceSelect';
import PaymentSelect from 'components/PaymentSelect';
import PayementModal from 'pages/Payment/PayementModal';
import _ from 'lodash';

type Values = {
  tasks: ViewProcTaskResponse[];
};
export type docListProps = {
  objectid?: number;
  procmodule?: string;
};
const TasksList = ({ objectid, procmodule }: docListProps) => {
  const [tasklist, settasklist] = useState<any[]>([]);

  const initialSearchValues = {
    entity: '',
    entityid: '' as any,
    filteringMode: '',
    holderid: '' as any,
    proccode: '',
    receiverRoleProfile: '',
    receiverType: '',
    receivertype: '',
    receiverid: '' as any,
    senderid: '' as any,
    taskid: '' as any,
    taskstatus: '',
    userid: '' as any,
  };
  const [searchParams, setsearchParams] = useState<any>(initialSearchValues);
  const [proccode, setproccode] = useState<string>();
  const [searchs, setsearchs] = useState(false);
  const [checkdocmodule, setcheckdocmodule] = useState('');

  let { refetch, isFetching } = useQuery(
    ['GetListProcTaskByFilter', searchParams],
    () =>
      GetListProcTaskByFilter(searchParams)
        .then((res) => {
          settasklist([]);
          settasklist(res.list);
          return res.list;
        })
        .catch((err) => {
          return [];
        }),
    { enabled: searchs || objectid !== undefined, refetchOnWindowFocus: false }
  );

  const [receivertype, setreceivertype] = useState('');

  const [selectedItem, setSelectedItem] = useState<Array<number>>([]);

  const columns = useMemo<DataGridColDef<ViewProcTaskResponse>[]>(
    () => [
      {
        dataIndex: 'objectreference',
        width: '100',
        filtrable: 'entity',
        filterComponent: (
          <ParListSelect
            onClear={() => {
              setcheckdocmodule('');
            }}
            allowClear
            parcode="DOCMODULE"
            onSelect={(e: any) => {
              setcheckdocmodule(e);
            }}
            defaultValue=""
          />
        ),
        render: (value, record) => (
          <div>
            <ModalController>
              {({ setVisible, visible }) => (
                <>
                  <a
                    onClick={() => {
                      setVisible(true);
                    }}
                  >
                    {record.objectreference}
                  </a>
                  {record.procmodule === 'THIRDPARTY' ? (
                    <ThirdPartyModal
                      tpId={Number(record.objectid)}
                      visible={visible}
                      onCancel={() => setVisible(false)}
                      onSuccess={() => setVisible(false)}
                      title=""
                      iscreate={false}
                    />
                  ) : record.procmodule === 'PROPOSAL' ? (
                    <ProposalModal
                      ctrid={Number(record.objectid)}
                      visible={visible}
                      onCancel={() => setVisible(false)}
                      onSuccess={() => setVisible(false)}
                      title=""
                      iscreate={false}
                    />
                  ) : record.procmodule === 'ASSET' ? (
                    <AssetDetails
                      assetid={Number(record.objectid)}
                      onCancel={() => setVisible(false)}
                      showAsModal
                      visible={visible}
                      phaseprop="PROPOSAL"
                      iscreate={false}
                    />
                  ) : record.procmodule === 'SINVOICE' ? (
                    <SIDetail
                      siid={Number(record.objectid)}
                      onCancel={() => setVisible(false)}
                      showAsModal
                      visible={visible}
                      showButtons={false}
                    />
                  ) : record.procmodule === 'CONTRACT' ? (
                    <ProposalModal
                      ctrid={Number(record.objectid)}
                      visible={visible}
                      onCancel={() => setVisible(false)}
                      onSuccess={() => setVisible(false)}
                      title=""
                      iscreate={false}
                    />
                  ) : record.procmodule === 'GUARANTY' ? (
                    <GuarantDetailModal
                      guarId={String(record.objectid)}
                      visible={visible}
                      onCancel={() => setVisible(false)}
                      onSuccess={() => setVisible(false)}
                      title=""
                      iscreate={false}
                    />
                  ) : record.procmodule === 'CINVOICE' ? (
                    <CIDetail
                      ciid={Number(record.objectid)}
                      onCancel={() => setVisible(false)}
                      showAsModal
                      visible={visible}
                    />
                  ) : record.procmodule === 'PAYMENT' ? (
                    <PayementModal
                      payid={Number(record.objectid)}
                      onCancel={() => setVisible(false)}
                      showAsModal
                      hideButtons
                      visible={visible}
                    />
                  ) : (
                    ''
                  )}
                </>
              )}
            </ModalController>
          </div>
        ),
      },
      {
        dataIndex: 'procmodule',
        width: '170px',
        filtrable: 'entityid',
        filterComponent:
          checkdocmodule === 'THIRDPARTY' ? (
            <ThirdPartyInput onlytpid />
          ) : checkdocmodule === 'PROPOSAL' ? (
            <ProposalSelect onlyctrid />
          ) : checkdocmodule === 'ASSET' ? (
            <AssetSelect onlyAssetId />
          ) : checkdocmodule === 'SINVOICE' ? (
            <SupplierInvoiceSelect onlysiid />
          ) : checkdocmodule === 'CONTRACT' ? (
            <ProposalSelect onlyctrid phase="ACTIVE" />
          ) : checkdocmodule === 'GUARANTY' ? (
            <GuarantySelect onlyGuarid />
          ) : checkdocmodule === 'CINVOICE' ? (
            <ClientInvoiceSelect onlyCiid />
          ) : checkdocmodule === 'PAYMENT' ? (
            <PaymentSelect onlyPayid />
          ) : checkdocmodule === 'COLLECTION' ? (
            <CollectionSelect onlyColid />
          ) : (
            <Input disabled defaultValue="Please select an object" />
          ),
        render: (value, record) => record?.modulename,
      },
      {
        dataIndex: 'proccodelabel',
        filtrable: 'proccode',
        width: '170px',
        filterComponent: (
          <ProcedureInput
            entity={checkdocmodule}
            onSelected={(value) => {
              setproccode(value);
            }}
          />
        ),
      },
      {
        dataIndex: 'tasklabel',
        width: '200px',
        filtrable: 'taskid',
        filterComponent: <TaskInput proccode={proccode} />,
        render: (tasklabel, record) => (
          <ModalControllerNV
            modal={({ setVisible, visible }) => (
              <TaskModal
                random={Math.round(_.random(10000) * 10000000)}
                entityId={record.objectid}
                entity={record.procmodule}
                entityName={record.procmodule}
                subentity=""
                subentityid={0}
                task={{
                  taskid: record.taskid,
                  tasklabel:
                    record.modulename +
                    ' ' +
                    record.objectreference +
                    ' - ' +
                    tasklabel,
                  funcode: record.funcode,
                  id: record.proctaskid,
                  lancode: '',
                  proccode: record.proccode,
                  procmodule: record.procmodule,
                  procrule: '',
                  serviceurl: record.serviceurl,
                  taskrule: '',
                  tasktriggermode: '',
                  tasktype: '',
                  subentity: '',
                  subentityid: 0,
                }}
                visible={visible}
                onCancel={() => {
                  setVisible(false);
                  refetch();
                }}
                onSuccess={() => {
                  // setVisible(false);
                  refetch();
                }}
              />
            )}
            content={({ setVisible, visible }) => (
              <a onClick={() => setVisible(true)}>{tasklabel}</a>
            )}
          />
        ),
      },
      {
        dataIndex: 'receivertype',
        width: '100',
        filtrable: 'receivertype',
        filterComponent: (
          <ParListSelect
            parcode="RECEIVTYPE"
            defaultValue=""
            allowClear
            onSelect={(e) => {
              setreceivertype(e);
            }}
          />
        ),
        render: (value, record) => record.receivertypelabel,
      },
      {
        dataIndex: 'receiverRoleProfile',
        filtrable:
          receivertype === 'UPROFILE' || receivertype === 'UROLE'
            ? 'receiverRoleProfile'
            : 'receiverid',
        filterComponent:
          receivertype === 'UPROFILE' || receivertype === 'UROLE' ? (
            <ParListSelect
              parcode={receivertype === 'UROLE' ? 'UROLE' : 'USERJOB'}
              allowClear
            />
          ) : receivertype === 'USER' ? (
            <UsersInput statusprops="ENABLED" />
          ) : (
            <Input disabled />
          ),
        render: (value, record) => record.receiverroleprofilelabel,
      },
      {
        dataIndex: 'sendername',
        width: '100',
        filtrable: 'senderid',
        filterComponent: <UsersInput statusprops="ENABLED" />,
      },

      {
        dataIndex: 'holdername',
        key: 'holder',
        width: '130',
        filtrable: 'holderid',
        filterComponent: <UsersInput statusprops="ENABLED" />,
      },
      {
        dataIndex: 'taskstatuslabel',
        width: '100',
        filtrable: 'taskstatus',
        filterComponent: <ParListSelect parcode="TASKSTATUS" />,
        render: (value, record) => (
          <Tag
            color={
              record.taskstatus === 'CLOSED'
                ? '#cd201f'
                : record.taskstatus === 'ACTIVE'
                ? 'green'
                : ''
            }
          >
            {record?.taskstatuslabel}
          </Tag>
        ),
      },
      {
        dataIndex: 'taskstatusdate',
        width: '100',
      },
    ],
    [checkdocmodule, proccode, refetch, searchParams, receivertype, tasklist]
  );

  const columnsFilter = () => {
    let columnsFiltred = columns;
    if (procmodule && objectid) {
      columnsFiltred = columnsFiltred.filter((column) => {
        return (
          column.dataIndex !== 'procmodule' && column.dataIndex !== 'objectid'
        );
      });
    } else if (procmodule) {
      columnsFiltred = columnsFiltred.filter((column) => {
        return column.dataIndex !== 'procmodule';
      });
    }

    return columnsFiltred;
  };

  return (
    <DF.Provider pagcode="TasksList">
      <DataGrid
        rowKey="proctaskid"
        dataSource={tasklist}
        columns={columnsFilter()}
        rowSelection={{
          hideSelectAll: true,
          type: 'checkbox',

          onSelect: (_, isSelected, selectedItems) => {
            setSelectedItem(selectedItems.map((item) => item.proctaskid));
          },
          columnTitle: (
            <MultiTaskAssignToUserButton
              proctaskidList={selectedItem?.map((item: any) => ({
                proctaskid: item,
              }))}
              label="assign"
              refetch={refetch}
            />
          ),
          columnWidth: 100,
          getCheckboxProps: (record) => {
            const closed = record.taskstatus === 'CLOSED';
            return {
              disabled: closed,
            };
          },
        }}
        titleComcode="TaskList"
        onSearch={(values) => {
          setsearchs(true);
          setsearchParams({
            ...searchParams,
            proccode: values.proccode,
            taskid: values.taskid,
            entity: checkdocmodule,
            entityid: values.entityid,
            receiverType: receivertype,
            receiverid:
              receivertype === 'USER' ? values.receiverid : ('' as any),
            receiverRoleProfile:
              receivertype === 'UPROFILE' || receivertype === 'UROLE'
                ? values.receiverRoleProfile
                : '',
            senderid: values?.senderid,
            holderid: values?.holderid,
            taskstatus: values?.taskstatus,
          });
        }}
        onClear={() => {
          setreceivertype('');
          setcheckdocmodule('');
        }}
        initialSearchValues={initialSearchValues}
        isLoading={isFetching}
      />
    </DF.Provider>
  );
};

export default TasksList;
